import { Image } from '../models/image.model';
import { ValidatorResult } from '../models/validation-result.model';
import { CrudService } from './crud.service';

export class ImagesService {
  private crudService: CrudService<Image>;

  constructor() {
    this.crudService = new CrudService<Image>('images');
  }

  public async get(id: string): Promise<ValidatorResult<Image>> {
    return await this.crudService.get(id);
  }

  public async create(image: Image): Promise<ValidatorResult<Image>> {
    return await this.crudService.post(image);
  }
}
